{
  "slug": "what-is-the-average-iq",
  "title": "গড় আই. কিউ. কত?",
  "description": "দেখুন কেন গড় আই. কিউ. সাধারণত. 100, কিভাবে মানদণ্ড বিভ্রান্তি এবং শতাংশ কাজ করে, এবং কিভাবে তুলনা দায়িত্বশীলভাবে ব্যাখ্যা করা যায়।",
  "summary": "আধুনিক আই. কে. স্কেলে, গড় মান নির্ধারণ করা হয়. 100. প্রায় দুই তৃতীয়াংশ রেফারেন্স জনসংখ্যার মধ্যে পড়ে 85 এবং 115.",
  "sections": [
    {
      "heading": "কেন গড় হচ্ছে 100",
      "paragraphs": [
        "সঠিক উত্তরের নির্দিষ্ট সংখ্যার উপর ভিত্তি করে নয়, আই. কিউ. স্কেলগুলোকে মানব নির্ধারিত করা হয়েছে। প্রকাশকরা কাঁচা ফলাফলকে এমনভাবে রূপান্তর করে যে রেফারেন্স গ্রুপের গড় মান হবে 100জনসংখ্যা এবং শিক্ষাগত অভিজ্ঞতার পরিবর্তনের সাথে সাথে পরীক্ষার পদ্ধতি পরিবর্তন করা হয়।",
        "একটি স্কোরের কাছাকাছি 100 এর মানে হচ্ছে নির্বাচিত নর্ম গ্রুপের মাঝের কাছাকাছি পারফরম্যান্স- কেউ উত্তর দেয়নি। 100 প্রশ্ন করে না, অথবা তার বুদ্ধিমত্তার পরিমাণ নির্দিষ্ট নয়।"
      ]
    },
    {
      "heading": "সাধারণ 85–115 পরিসীমা",
      "paragraphs": [
        "এর মানদণ্ড বিকৃতির সাথে 15, সম্পর্কে 68স্বাভাবিক বিতরণ 85 টু 115, এবং সম্পর্কে 95% থেকে 70 টু 130এগুলো প্রায়তামাফিক।",
        "পারসেনটিলগুলো সহজেই বোঝা যায়: 100 ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ 50% 1- তম শতাংশ, 115 নীচে 84, এবং 85 নীচে 16ত্বা, হা ।"
      ]
    },
    {
      "heading": "তুলনা সাবধানে ব্যবহার করুন",
      "paragraphs": [
        "একটি স্কোরের জন্য উপযুক্ত বয়স এবং বর্তমান পরীক্ষার সংস্করণের প্রয়োজন। ভাষা, শিক্ষা, স্বাস্থ্য এবং প্রসঙ্গ বিষয়। দেশ বা জনসংখ্যার তুলনা বিশেষভাবে নমুনা এবং পদ্ধতির প্রতি সংবেদনশীল।",
        "একজন ব্যক্তির জন্য, সম্পূর্ণ সঠিক হিসাবে মোট হিসাবে বিবেচনা করার চেয়ে একটি বিশ্বাসযোগ্যতা অন্তর এবং সাবটেস্ট প্রোফাইলটি আরও উপকারী।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "বরফ 100 ভালো আই. কিউ স্কোর?",
      "answer": "একশো 100 এই চিত্রটি নরম গ্রুপের কেন্দ্রে অবস্থিত এবং এটি মূল্যায়িত ক্ষমতার উপর সাধারণ কার্যকারিতাকে প্রতিনিধিত্ব করে।"
    },
    {
      "question": "এর উপরে কত শতাংশ মানুষ স্কোর করেছে? 100?",
      "answer": "উপরের অর্ধেক স্কোর 100 এবং এর অর্ধেক নিচে, যদিও বাস্তব নরম বন্টন সম্পূর্ণ সমতল নয়."
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
